import axios from "axios";

export const request = (registry, captchaToken) =>
  axios.post("/api/request-registration/request", registry, {
    headers: {
      Captcha: captchaToken
    }
  });

export const requestAccountExist = (registry, captchaToken) =>
  axios.post("/api/request-registration/account-exist", registry, {
    headers: {
      Captcha: captchaToken
    }
  });

export const checkIsHelper = (uuid) =>
  axios.get(`/api/request-registration/check-is-helper/${uuid}`);

export const checkIsOwner = (uuid) =>
  axios.get(`/api/request-registration/check-is-owner/${uuid}`);

export const resentMail = (uuid) =>
  axios.post(`/api/request-registration/resend/${uuid}`);

export const deleteRegistration = (uuid) =>
  axios.delete(`/api/request-registration/${uuid}`);

export const validateInvitationCode = (guid) =>
axios.get(`/api/request-registration/validate-invitation-code/${guid}`);

export const validateOwnerAssistant = (guid) => 
axios.get(`/api/request-registration/validate-owner-helper/${guid}`)